module.exports = __webpack_public_path__ + "static/media/immobilien_icon_white.7608407d.svg";